export default __webpack_public_path__ + "media/vendors/app_store_download-57695dfa.svg";